module.exports = __webpack_public_path__ + "static/img/setting.8dd16d9d.png";